import React, { useMemo } from 'react';

const WordCloudSlide: React.FC<{
  idx: number;
  activeSlideIdx: number;
  url: string;
}> = ({ url, idx, activeSlideIdx }) => {
  const token = useMemo(() => localStorage.getItem('token'), []);
  if (idx !== activeSlideIdx) return null

  return (
    <div>
      <div>
        <img
          style={{
            width: '100%',
            border: '1px solid black'
          }}
          src={url + `?token=${token}`}
          alt="wordcloud"
        />
      </div>
    </div>
  )
}

export default WordCloudSlide
